export const successMessage = (item, action) =>
  item + " " + action + " Successfully";
export const errorMessage = (item, action) => item + " was not " + action;
